import { teamMembers } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const PartnerList = ({ items }) => (
  <div className="why-list" data-testid="why-list">
    <ul data-testid="why-items">
      {items.map((item, index) => (
        <li key={item} data-testid={`why-item-${index}`}>
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const TeamCards = ({ members, roles, cardAlt }) => (
  <div className="why-cards" data-testid="why-cards">
    {members.map((member, index) => (
      <div className="why-card team-card" key={member.name} data-testid={`team-card-${index}`}>
        <img
          src={member.photo}
          alt={member.name}
          loading="lazy"
          data-testid={`team-photo-${index}`}
          className="team-photo"
        />
        <div className="why-card-text" data-testid={`team-text-${index}`}>
          <h3 data-testid={`team-name-${index}`}>{member.name}</h3>
          <p data-testid={`team-role-${index}`}>{roles[member.id]}</p>
        </div>
        <img
          src={member.card}
          alt={cardAlt[member.id]}
          loading="lazy"
          data-testid={`team-card-image-${index}`}
          className="team-business-card"
        />
      </div>
    ))}
  </div>
);

const WhySection = () => {
  const { copy } = useLanguage();

  return (
    <section className="section section-alt" id="why" data-testid="why-section">
      <div className="container" data-testid="why-container">
        <div className="section-header">
          <p className="section-kicker" data-testid="why-kicker">
            {copy.why.kicker}
          </p>
          <h2 className="section-title" data-testid="why-title">
            {copy.why.title}
          </h2>
        </div>
        <div className="why-grid" data-testid="why-grid">
          <PartnerList items={copy.why.partnerPoints} />
          <TeamCards members={teamMembers} roles={copy.why.roles} cardAlt={copy.why.cardAlt} />
        </div>
      </div>
    </section>
  );
};

export default WhySection;